import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService, OAuthSuccessEvent } from 'angular-oauth2-oidc';
import { AuthenticationService } from '../../service/authentication.service';
import { IdentityProviderIdentifier } from '../../config/oauth2/idp.config';
import { Profile } from '../../model/profile.type';
import { HttpClient } from '@angular/common/http';

/* eslint-disable require-await */
@Injectable()
export class AuthenticationServiceMock extends AuthenticationService {

    constructor(public override router: Router, private http: HttpClient) {
        super({} as OAuthService, router, http);
    }

    private loggedInStatus: boolean = true; // TODO will change to some user-details etc.

    public override logout(): void {
        this.loggedInStatus = false;
        sessionStorage.clear();
        this.router.navigateByUrl('/')
    }

    public override async useIdpAndLoadDiscoveryDocument(idp: IdentityProviderIdentifier, persist: boolean = true): Promise<OAuthSuccessEvent> {
        return { type: 'discovery_document_loaded', info: {} };
    }

    public override login(): void {
        this.router.navigateByUrl('/auth/login-redirect')
    }

    public override getToken(): string | undefined {
        if (this.isLoggedIn()) {
            return 'VIEWER'; // will be used as roles
        } else {
            return undefined;
        }
    }

    public override async initAuthentication(): Promise<void> {
    }

    public override async tryLoginFromRedirect(): Promise<boolean> {
        this.loggedInStatus = true;
        return true;
    }

    public override isLoggedIn(): boolean {
        return this.loggedInStatus;
    }


    public override getProfile(): Profile {
        return {
            email: 'iq@energy.eon.com',
            name: 'Not a real user',
            tenants: [
                {
                    id: 'WESTFALENLAND',
                    name: 'Westfalenland',
                },
            ],
        };
    }
}
